import type { ReactNode } from 'react';
import { Deeplinks } from './Deeplinks.tsx';
import { Links } from './Links.tsx';
import { NetworkAccounts } from './NetworkAccounts.tsx';
import { Networks } from './Networks.tsx';
import { Programs } from './Programs.tsx';
import './affiliate.css';

export const AFFILIATE_SHORTCUTS: [string, string][] = [
  ['g then n / o / p / d / l', 'Go to Networks, Network accounts, Programs, Deeplinks, Links'],
  ['n', 'Networks, Programs, Deeplinks: new item'],
  ['shift + j / k', 'Deeplinks: move the selected parameter down / up'],
];

/** The affiliate page for a path, or null when the path is not one of ours. */
export function affiliatePage(path: string): ReactNode | null {
  switch (path) {
    case '/networks':
      return <Networks />;
    case '/network-accounts':
      return <NetworkAccounts />;
    case '/programs':
      return <Programs />;
    case '/deeplinks':
      return <Deeplinks />;
    case '/links':
      return <Links />;
    default:
      return null;
  }
}
